import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Col, Row, Button, Card, ButtonGroup } from 'react-bootstrap';
import { useNotification } from 'utils';
export const NotificationTest = () => {
    const { liveNotification } = useNotification();
    const showSuccess = () => {
        const notification = [
            'success',
            'this is success message toast',
        ];
        console.log('notification => ', notification);
        liveNotification(...notification);
    };
    const showInfo = () => {
        const notification = [
            'info',
            'this is info message toast',
        ];
        console.log('notification => ', notification);
        liveNotification(...notification);
    };
    const showError = () => {
        const notification = [
            'error',
            'this is error message toast',
        ];
        console.log('notification => ', notification);
        liveNotification(...notification);
    };
    return (_jsx(_Fragment, { children: _jsx(Card, Object.assign({ className: 'p-3 w-100' }, { children: _jsx(Row, { children: _jsx(Col, { children: _jsxs(ButtonGroup, { children: [_jsx(Button, Object.assign({ onClick: showSuccess, variant: 'primary' }, { children: "Success notification" })), _jsx(Button, Object.assign({ onClick: showInfo, variant: 'info' }, { children: "Info notification" })), _jsx(Button, Object.assign({ onClick: showError, variant: 'danger' }, { children: "Error notification" }))] }) }) }) })) }));
};
